var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4157 8.76117C17.6425 8.66137 17.9069 8.70506 18.0896 8.87254L23.0896 13.4559C23.3441 13.6891 23.3613 14.0845 23.128 14.3389C22.8948 14.5934 22.4994 14.6106 22.245 14.3773L18.2923 10.754L18.2923 22.6666C18.2923 23.0118 18.0125 23.2916 17.6673 23.2916C17.3221 23.2916 17.0423 23.0118 17.0423 22.6666L17.0423 9.33326C17.0423 9.08541 17.1888 8.86097 17.4157 8.76117ZM14.334 8.70826C14.6792 8.70826 14.959 8.98809 14.959 9.33326L14.959 22.6666C14.959 22.9145 14.8125 23.1389 14.5857 23.2387C14.3588 23.3385 14.0944 23.2948 13.9117 23.1273L8.91166 18.544C8.65721 18.3107 8.64002 17.9154 8.87327 17.6609C9.10651 17.4065 9.50187 17.3893 9.75632 17.6225L13.709 21.2458L13.709 9.33326C13.709 8.98809 13.9888 8.70826 14.334 8.70826Z",
    fill: "#9B7CC8",
    stroke: "#9B7CC8",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#E8E1F6",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.c7a0e9b83091d465c2fab58ea5006381.svg";
export { ForwardRef as ReactComponent };